export default __webpack_public_path__ + "static/media/mobile-alert-zone.1f66fab0.svg";